import { render, staticRenderFns } from "./AppointmentListCard.vue?vue&type=template&id=03fbadcf&scoped=true"
import script from "./AppointmentListCard.vue?vue&type=script&lang=ts"
export * from "./AppointmentListCard.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentListCard.vue?vue&type=style&index=0&id=03fbadcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fbadcf",
  null
  
)

export default component.exports